import React, { Component } from 'react';
import Modal from "react-bootstrap/Modal";
import { isSet } from '../../../Utils/CommonFunctions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import { removeActivePopupPageAction } from '../../../store/actions/PagesAction';
import PagesRenderComponent from './PagesRenderComponent';
// import './custom.css';
import '../../LayoutContainer/custom.css'

// import "bootstrap/dist/css/bootstrap.min.css"; // ✅ required

// import { setFromMappingPayloadAction, setToPagesAction,clearPagesConfiguration } from '../../../../store/actions/PagesAction';
class PagesInterface extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentActivePage:null
        }

    }
    componentDidMount = async () => {
       
    }
    componentDidUpdate = (prevProps)=>{
         const {activePage,pageFlows} = this.props;
         
         if(prevProps.activePage!==activePage){
              this.setState({
                currentActivePage:activePage
              });
         }
    }
    
   
   

    
    render() {
         const {pageFlows,pageType} = this.props;
         const {activePopups,pageData} = pageFlows;
        console.log('pageFlows-testing...',activePopups,pageFlows);
        // console.log('pagesFlowss',pageFlows)
        if(activePopups.length>0){
            return   activePopups.map((activePopup,popupIndex)=>{
             const pagesConfigData = isSet(pageData?.[activePopup],null);
            //   console.log('pageFlows-pagesConfigData',pagesConfigData);
            console.log('formPayload-11',pagesConfigData);
             const {pages={},config_type=''} = pagesConfigData || {};
             let isShow = false;
             let composedHtml = '';
             if(config_type==='DIRECT' || pagesConfigData?.type==='PAGES'){
                isShow = true;
                composedHtml = `<Root><style>${pages.css}</style><scm:body class="scm-page-preview" id="scm">${pages.html}</scm:body><script>${pages.js}</script></Root>`;
            }
           let zIndexVal = 1100+popupIndex;
             const sizeMap = {
                DEFAULT: '',
                SMALL: 'sm',
                MEDIUM: 'md',
                LARGE: 'lg',
                XL: 'xl',
                FULL_SCREEN: 'fullscreen',
                CUSTOM: 'custom'
                };
                //   const customStyle = {
                //     zIndex: zIndexVal,
                //     width: `${pages?.width}px`,//"600px",
                //     height: `${pages?.height}px`,//"400px",
                //     overflow:'visible',
                //     marginLeft:'auto',
                //     marginRight:'auto',
                //     maxWidth:"none"
                //     // maxWidth: "90%",
                //     // maxHeight: "90%",
                // };
             //format
            //  console.log('customStyle',customStyle)
             return (
            <>
            {(pages?.display_type==='POPUP' && pageType==='POPUP') && 
                <Modal  
                    enforceFocus={false}
                    restoreFocus={false}
                    onHide={()=>this.props.removeActivePopupPageAction(activePopup)}
                    backdrop="static"
                    show={isShow} 
                    keyboard={false} 
                    className={`pages-my-modal ${
                        sizeMap[pages?.format] === "custom" ? "custom-size" : ""
                      }`}
                    // size={["sm", "md", "lg", "xl"].includes(sizeMap[pages?.format]) ? sizeMap[pages?.format] : 'xl'}
                     size={
                        sizeMap[pages?.format] &&
                        ["sm", "md", "lg", "xl"].includes(sizeMap[pages?.format])
                        ? sizeMap[pages?.format]
                        : ''
                    }
                    backdropClassName={`custom-backdrop-${popupIndex} `}
                    style={
                        sizeMap[pages?.format] === "custom"
                          ? {
                              "--page-width": pages?.width + "px",
                              "--page-height": pages?.height + "px",
                              "--page-maxWidth": "none",
                              "--zIndex": zIndexVal,
                            }
                          : {
                              "--zIndex": zIndexVal,
                            }
                      }
                    fullscreen={sizeMap[pages?.format] === 'fullscreen'}>
                <Modal.Header closeButton>
                    <h4 className="modal-title secondary_color pl-2 mb-0"> {pages?.page_name} </h4>
                </Modal.Header>
                <Modal.Body>
                    {composedHtml && (
                         <PagesRenderComponent
                            composedHtml={composedHtml}
                            pageType={'POPUP'}
                            currentPage={activePopup}
                            outputResponse={pagesConfigData?.pages?.response}
                            inputParams={pagesConfigData?.pages?.params || {}}
                            pagesConfigData={pagesConfigData} />
                       
                    )}
                </Modal.Body>
                </Modal>
            }
            </>

        )
            })
        }else{
            return <></>
        }
          
       
    }
}

const mapDispatchToProps = dispatch => {
    return {
        Loader: (bool) => dispatch(actions.loader(bool)),
        succMessage: (msg) => dispatch(actions.succMessage(msg)),
        failMessage: (msg) => dispatch(actions.failMessage(msg)),
        warningMessage: (msg) => dispatch(actions.warningMessage(msg)),
        removeActivePopupPageAction:(configKey)=>dispatch(removeActivePopupPageAction(configKey)),
        // setToPagesAction:(payload)=>dispatch(setToPagesAction(payload)),
        // clearPagesConfiguration:()=>dispatch(clearPagesConfiguration())
    };
}
const mapStateToProps = (state) => { 
  return {
    //   fromMappingFields:state.PagesReducer.pagesConfiguration.from_page_mapping,
      resourcesList:state.PagesReducer.resourcesList,
      activePage:state.PagesReducer.activePage,
      pageFlows:state.PagesReducer.pageFlows,
  };
}
export default
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withRouter(PagesInterface));